import { Box, Button } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EmptyState } from "../Components/ui/empty-state";
import { ImFilesEmpty } from "react-icons/im";
import { GoArrowLeft } from "react-icons/go";
import { setDynamicTitle } from "../Utils/dynamicTitleManager";

export const PageNotFound = () => {
  // Use dynamic title management
  useEffect(() => {
    setDynamicTitle("Page Not Found");
  }, []);

  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box padding="2rem" textAlign="center">
        <EmptyState
          colorPalette="red"
          icon={<ImFilesEmpty />}
          title="Page Not Found"
          description="The page you’re looking for doesn’t exist or may have been moved. Please go back or return to the homepage."
        >
          <Box
            display="flex"
            gap="1rem"
            justifyContent="center"
            marginTop="2rem"
          >
            <Button variant="outline" onClick={() => navigate(-1)}>
              <GoArrowLeft />
              Go Back
            </Button>
            <Button colorScheme="red" onClick={() => navigate("/")}>
              Home
            </Button>
          </Box>
        </EmptyState>
      </Box>
    </Box>
  );
};